import React, { useEffect } from 'react';
import { Wrench, RotateCcw, TrendingUp } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Maintenance = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('maintenance');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Routine Maintenance',
      icon: Wrench,
      description: 'Daily, weekly, and monthly maintenance tasks to keep SQL Server running optimally.',
      scripts: getContentByCategory('Miscellaneous', 'Routine Maintenance')
    },
    {
      name: 'Index Maintenance',
      icon: RotateCcw,
      description: 'Index rebuilding, reorganization, and optimization strategies for better performance.',
      scripts: getContentByCategory('Miscellaneous', 'Index Maintenance')
    },
    {
      name: 'Health Monitoring',
      icon: TrendingUp,
      description: 'System health checks, performance monitoring, and proactive maintenance alerts.',
      scripts: getContentByCategory('Miscellaneous', 'Health Monitoring')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Miscellaneous</h1>
        <p className="page-description">
          Build resilient SQL Server environments with comprehensive maintenance procedures. 
          Proactive scripts and monitoring tools for optimal database performance and reliability.
        </p>
      </div>

      <CategoryTabs 
        category="Miscellaneous"
        scripts={getContentByCategory('Miscellaneous')}
        articles={getContentByCategory('Miscellaneous', null, 'articles')}
        faqs={getContentByCategory('Miscellaneous', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Maintenance;